import { EMPTY_STRING } from "shared/constants";
import { IFormInput } from "./types";

export const defaultValues: IFormInput = {
  agingAnalysisRequired: null,
  frequencyId: null,
  additionalInvoicingInformation: EMPTY_STRING,
};
